export function SlackMockup() {
  return (
    <div
      style={{
        background: '#fff', borderRadius: 12, border: '1px solid #E8E4DF',
        overflow: 'hidden',
      }}
    >
      {/* Channel header */}
      <div
        style={{
          padding: '10px 16px', background: '#f8f7f5',
          borderBottom: '1px solid #E8E4DF',
          display: 'flex', alignItems: 'center', gap: 8,
          fontSize: 13, fontWeight: 600, color: '#1a1216',
        }}
      >
        <span style={{ fontSize: 16 }}>#</span> email-alerts
      </div>

      {/* Message */}
      <div style={{ padding: 16 }}>
        <div style={{ display: 'flex', gap: 10 }}>
          {/* Avatar */}
          <div
            style={{
              width: 32, height: 32, borderRadius: 6, background: '#FF6B00',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <svg width="18" height="14" viewBox="0 0 18 14" aria-hidden="true">
              <path d="M2 8L9 13L16 8" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              <line x1="2" y1="4" x2="9" y2="4" stroke="#fff" strokeWidth="1.2" strokeLinecap="round" opacity="0.5" />
            </svg>
          </div>

          {/* Content */}
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 6 }}>
              <span style={{ fontWeight: 700, fontSize: 13 }}>One-Email</span>
              <span style={{ fontSize: 11, color: '#777' }}>2 min ago</span>
            </div>
            <div
              style={{
                background: '#fef2f2', borderLeft: '3px solid #ef4444',
                padding: '12px 14px', borderRadius: '0 8px 8px 0',
                fontSize: 13, lineHeight: 1.6,
              }}
            >
              <div style={{ fontWeight: 700, color: '#ef4444', marginBottom: 4 }}>
                Bounce rate warning
              </div>
              <div style={{ color: '#666' }}>
                <strong>updates.yourapp.com</strong> bounce rate hit 3.2%
                <br />
                Threshold: 3.0% · Last 24h: 850 sent, 27 bounced
                <br />
                <span
                  style={{
                    color: '#FF6B00', fontWeight: 600, fontSize: 12,
                    cursor: 'pointer',
                  }}
                >
                  View details →
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
